export default "__VITE_ASSET__ORa_oi1o__"